<template>
  <div>
    <Ppt></Ppt>
    <Divider></Divider>
    <Intro1 />
    <Divider1></Divider1>
    <ProductTable></ProductTable>
    <!-- <Divider3></Divider3> -->
  </div>
</template>

<script>
import Ppt from "../components/ppt.vue";
import Divider from "../components/divider.vue";
import Intro from "../components/intro.vue";
import Intro1 from "../components/intro1.vue";
import Divider1 from "../components/divider1.vue";
import Divider3 from "../components/divider3.vue";
import Card3 from "../components/card3.vue";
import Cardteam from "../components/cardteam.vue";
import Card1 from "../components/card1.vue";
import ProductTable from "../components/productTable.vue";
import Card2 from "../components/card2.vue";

export default {
  components: {
    Ppt,
    Divider,
    Intro,
    Divider1,
    Divider3,
    Card3,
    Card1,
    Card2,
    Cardteam,
    Intro1,
    ProductTable
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/main.vue